var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDaifahuo = function SvgDaifahuo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "daifahuo_svg__a",
    d: "M0 0h26v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "daifahuo_svg__c",
    d: "M0 20h26V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "daifahuo_svg__e",
    d: "M0 20h26V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "daifahuo_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#daifahuo_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5v17h22.997l.003-17h-23ZM24 18.18v.909-.909ZM24 20H2c-1.103 0-2-.816-2-1.819V1.818C0 .815.897 0 2 0h22c1.103 0 2 .815 2 1.818v16.363C26 19.184 25.103 20 24 20Z",
    fill: "#333",
    mask: "url(#daifahuo_svg__b)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "daifahuo_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#daifahuo_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m15.282 13.006-2.232-1.351-2.232 1.351a.998.998 0 0 1-1.518-.855V1.5h1.207v9.74l2.025-1.038a1.004 1.004 0 0 1 1.036 0l1.996 1.038V1.5H16.8v10.651a.998.998 0 0 1-1.518.855Z",
    fill: "#333",
    mask: "url(#daifahuo_svg__d)"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#333",
    y: 12,
    width: 8,
    height: 1.5,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#333",
    x: 18,
    y: 12,
    width: 8,
    height: 1.5,
    rx: 0.75
  }))));
};

export default SvgDaifahuo;